import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Modal, Image, Button } from "react-bootstrap";
import Switch from "react-switch";
import { useFormik } from "formik";
// import * as yup from "yup";
import Alert from "react-s-alert";
import { TopTextReusableComponent } from "../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { BackLogoIconButton } from "../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { DesktopTabDesign } from "./DesktopTabDesign";
import {
  ReusableOnboardingButton,
  // ReusableOnboardingLink,
} from "../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { ToggleButtonReuse } from "../AllButton/ToggleButtonReuse";
import { MobileTabDesign } from "./MobileTabDesign";
import Media from "react-media";
import { MobileTopHeader } from "../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  update_new_subscription_for_vendor,
  logOutUser,
  update_vendor_profile,
} from "../../../../../store/actions/authAction";
// import { SliderReusableComponent } from "../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
// import { AmealioLoader } from "../../../../Loader/AmealioLoader";

export const MultiServiceManagementScreen = ({
  state,
  localProps,
  ...props
}) => {
  let history = useHistory();
  const [openModel, setModel] = useState(false);
  const formik = useFormik({
    initialValues: {
      casual_dining: false,
      listing: false,
      offer_management: false,
      scan_and_pay: false,
      event_management: false,
      experience_management: false,
      live_streaming: false,
      seating: false,
      ordering: false,
      menu_setup: false,
      voice_services: false,
      manage_staff_licence: false,
    },

    onSubmit: (values) => {
      const token = props?.auth?.user?.accessToken;
      const subscriptionId = props?.subscription?._id;
      let formData = props?.allSubscriptionsData;
      formData.multi_service_business_status.experience_management = {
        value :  values?.experience_management,
        ...formData.multi_service_business_status.experience_management
      };
      formData.casual_dining = false;
      formData.fast_food_dining = false;
      formData.hospitality_hotels = false;
      formData.multi_service_business = true;
      formData.multi_service_business_status.listing = values?.listing;
      formData.multi_service_business_status.offer_management.value =
        values?.offer_management;
      formData.multi_service_business_status.scan_and_pay.value =
        values?.scan_and_pay;
      formData.multi_service_business_status.event_management.value =
        values?.event_management;
      formData.multi_service_business_status.live_streaming.value =
        values?.live_streaming;
      formData.multi_service_business_status.seating.value = values?.seating;
      formData.multi_service_business_status.ordering.value = values?.ordering;
      formData.multi_service_business_status.menu_setup.value =
        values?.menu_setup;
      formData.multi_service_business_status.voice_services =
        values?.voice_services;
      formData.multi_service_business_status.manage_staff_licence =
        values?.manage_staff_licence;

      props.update_new_subscription_for_vendor(
        subscriptionId,
        formData,
        token,
        onSuccess
      );
    },
  });

  const onSuccess = (e) => {
    Alert.success("<h4>Subscription add successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    handleCloseSuccess();
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  const handleCloseSuccess = (e) => {
    setModel(!openModel);
  };

  const onFinalSuccess = (e) => {
    const vendor_id = props?.auth?.user?.VendorUser?._id;
    const formData = {
      have_submited_details_yourself: true,
      subscription: {
        ordering: formik.values?.ordering,
        seating: formik.values?.seating,
        event: formik.values?.event_management,
      },
    };
    props.update_vendor_profile(formData, vendor_id, callback);
  };

  const callback = (e) => {
    props.logOutUser();
    localStorage.clear();
    // props.history.push("/");
    window.location.reload();
  };

  useEffect(() => {
    if (props && props?.subscriptionData) {
      let data = props?.subscriptionData;
      formik.setFieldValue("listing", data?.listing);
      formik.setFieldValue("offer_management", data?.offer_management?.value);
      formik.setFieldValue("scan_and_pay", data?.scan_and_pay?.value);
      formik.setFieldValue("event_management", data?.event_management?.value);
      formik.setFieldValue("experience_management", data?.experience_management?.value);
      formik.setFieldValue("live_streaming", data?.live_streaming?.value);
      formik.setFieldValue("seating", data?.seating?.value);
      formik.setFieldValue("ordering", data?.ordering?.value);
      formik.setFieldValue("menu_setup", data?.menu_setup?.value);
      formik.setFieldValue("voice_services", data?.voice_services);
      formik.setFieldValue("manage_staff_licence", data?.manage_staff_licence);
    }
  }, [props?.subscriptionData]);

  const listingServicesHandler = () => {
    formik.setFieldValue("listing", !formik.values.listing);
  };
  const offerManagementHandler = () => {
    formik.setFieldValue("offer_management", !formik.values.offer_management);
    history.push("/multi-service/offers");
  };
  const scanAndPayHandler = () => {
    formik.setFieldValue("scan_and_pay", !formik.values.scan_and_pay);
    history.push("/multi-service/scanandpay");
  };
  // const eventManagementHandler = () => {
  //   formik.setFieldValue("event_management", !formik.values.event_management);
  //   history.push("/multi-service/events");
  // };
  
  const experienceManagementHandler = () => {
    formik.setFieldValue("experience_management", !formik.values.experience_management);
    history.push("/multi-service/experience-management");
  };

  const liveStreamingHandler = () => {
    formik.setFieldValue("live_streaming", !formik.values.live_streaming);
    history.push("/multi-service/livestreaming");
  };
  const seatingHandler = () => {
    formik.setFieldValue("seating", !formik.values.seating);
    history.push("/multi-service/seatingmanagement");
  };
  const orderingHandler = () => {
    formik.setFieldValue("ordering", !formik.values.ordering);
    history.push("/multi-service/ordering");
  };
  const menuSetupHandler = () => {
    if (
      props?.subscriptionData &&
      props?.subscriptionData?.ordering &&
      props?.subscriptionData?.ordering?.value
    ) {
      if ((props?.restaurantDetails?.pos?.restId &&
        props?.restaurantDetails?.pos?.restId != "") ||
        props?.subscriptionData &&
        props?.subscriptionData?.ordering &&
        props?.subscriptionData?.ordering?.order_general?.value
      ) {
        if (
          props?.subscriptionData?.ordering?.take_away?.value ||
          props?.subscriptionData?.ordering?.cubside_delivery?.value ||
          props?.subscriptionData?.ordering?.dine_in_order?.value ||
          props?.subscriptionData?.ordering?.catering_banquet?.value ||
          props?.subscriptionData?.ordering?.home_delivery?.value
        ) {
          formik.setFieldValue("menu_setup", !formik.values.menu_setup);
          history.push("/multi-service/menusetup");
        } else {
          alert(
            "Please add atleast one service in ordering. ex: take away, cubside delivery, dine in order, catering banquet, home delivery"
          );
        }
      } else {
        alert("Please complete fill general taxes in ordering section.");
      }
    } else {
      alert("Please Complete Ordering Information");
    }
  };

  // if (props.auth.loader === true) {
  //   return (
  //     <React.Fragment>
  //       <AmealioLoader />
  //     </React.Fragment>
  //   );
  // } else {
  return (
    <React.Fragment>
      {/* <Media query="(min-width: 992px)">
        <div className="col-12">
          <BackLogoIconButton
            displayBackText={true}
            workWithLinkORClick={true}
            notDisplaProgressBar={true}
            displayArrow={true}
            backButtonClicked={props.backButtonClicked}
          />
        </div>
      </Media>
      <Media query="(max-width: 991px)">
        <MobileTopHeader link={true} onLink={"/subscriptionhome"} />
      </Media>
      <div className="onboarding_process_screen-button-map">
        <div>
          <TopTextReusableComponent
            headingText="Subscription"
            headingParagraph="Enter the information about the food type provided in your restaurant."
          />
        </div>
        <div>
          <Media query="(min-width: 768px)">
            <DesktopTabDesign state={state} localProps={localProps} />
          </Media>
          <Media query="(max-width: 767px)">
            <MobileTabDesign state={state} localProps={localProps} />
          </Media>
        </div> */}
      <div className="col-12 casual-fastfood-hospitality-screen">
        {/* <ToggleButtonReuse
            mainText="Listing Service"
            checkedBox={formik.values.listing}
            onChange={() =>
              formik.setFieldValue("listing", formik.values.listing)
            }
          /> */}
        <div className="casual-fastfood-hospitality-screen-toggle">
          <div className="d-flex justify-content-between w-100">
            <h4>Listing Service</h4>
            <Switch
              checked={formik.values.listing}
              onChange={() => listingServicesHandler()}
              offColor="#EEEEEE"
              onColor="#EEEEEE"
              offHandleColor="#d3d3d3"
              onHandleColor="#59F832"
              handleDiameter={16}
              uncheckedIcon={false}
              checkedIcon={false}
              height={10}
              width={27}
              boxShadow="-2px 0px 5px #0000003B"
              activeBoxShadow="-2px 0px 5px #0000003B"
              id="material-switch"
            />
          </div>
          <div
            className="d-flex rightside-toggle-buttons-subscription-menu"
            // style={{ minWidth: "150px", marginLeft: "25px" }}
          >
            {/* {formik.values.listing && (
                <>
                  <Button
                    variant="link"
                    className="enIconBtn mr-3"
                    onClick={() => {
                      // history.push("/")
                    }}
                  >
                    <Image
                      src={require("../../../../../assets/images/UserManagement/eye.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button>
                  <Button
                    variant="link"
                    className="enIconBtn mr-3"
                    onClick={() => {
                      // viewType(2);0
                    }}
                  >
                    <Image
                      src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </Button>{" "}
                </>
              )} */}
          </div>
        </div>
        {formik.values.offer_management ? (
          <ToggleButtonReuse
            mainText="Offers Management"
            checkedBox={formik.values.offer_management}
            onChange={() =>
              formik.setFieldValue(
                "offer_management",
                !formik.values.offer_management
              )
            }
            clickHandle={(e) => {
              props.history.push({
                pathname: "/multi-service/offers",
                state: { access: e },
              });
            }}
          />
        ) : (
          <ToggleButtonReuse
            mainText="Offers Management"
            checkedBox={formik.values.offer_management}
            onChange={() => offerManagementHandler()}
          />
        )}
        {formik.values.scan_and_pay ? (
          <ToggleButtonReuse
            mainText="Scan & Pay"
            checkedBox={formik.values.scan_and_pay}
            onChange={() =>
              formik.setFieldValue("scan_and_pay", !formik.values.scan_and_pay)
            }
            clickHandle={(e) => {
              props.history.push({
                pathname: "/multi-service/scanandpay",
                state: { access: e },
              });
            }}
          />
        ) : (
          <ToggleButtonReuse
            mainText="Scan & Pay"
            checkedBox={formik.values.scan_and_pay}
            onChange={() => scanAndPayHandler()}
          />
        )}
        {/* {formik.values.event_management ? (
          <ToggleButtonReuse
            mainText="Events Management"
            checkedBox={formik.values.event_management}
            onChange={() =>
              formik.setFieldValue(
                "event_management",
                !formik.values.event_management
              )
            }
            clickHandle={(e) => {
              props.history.push({
                pathname: "/multi-service/events",
                state: { access: e },
              });
            }}
          />
        ) : (
          <ToggleButtonReuse
            mainText="Events Management"
            checkedBox={formik.values.event_management}
            onChange={() => eventManagementHandler()}
          />
        )}
         */}
        {formik.values.experience_management ? (
          <ToggleButtonReuse
            mainText="Experience Management"
            checkedBox={formik.values.experience_management}
            onChange={() =>
              formik.setFieldValue(
                "experience_management",
                !formik.values.experience_management
              )
            }
            clickHandle={(e) => {
              props.history.push({
                pathname: "/multi-service/experience-management",
                state: { access: e },
              });
            }}
          />
        ) : (
          <ToggleButtonReuse
            mainText="Experience Management"
            checkedBox={formik.values.experience_management}
            onChange={() => experienceManagementHandler()}
          />
        )}
        {formik.values.live_streaming ? (
          <ToggleButtonReuse
            mainText="Live Streaming"
            checkedBox={formik.values.live_streaming}
            onChange={() =>
              formik.setFieldValue(
                "live_streaming",
                !formik.values.live_streaming
              )
            }
            clickHandle={(e) => {
              props.history.push({
                pathname: "/multi-service/livestreaming",
                state: { access: e },
              });
            }}
          />
        ) : (
          <ToggleButtonReuse
            mainText="Live Streaming"
            checkedBox={formik.values.live_streaming}
            onChange={() => liveStreamingHandler()}
          />
        )}
        {formik.values.seating ? (
          <ToggleButtonReuse
            mainText="Seating"
            checkedBox={formik.values.seating}
            onChange={() =>
              formik.setFieldValue("seating", !formik.values.seating)
            }
            clickHandle={(e) => {
              props.history.push({
                pathname: "/multi-service/seatingmanagement",
                state: { access: e },
              });
            }}
          />
        ) : (
          <ToggleButtonReuse
            mainText="Seating"
            checkedBox={formik.values.seating}
            onChange={() => seatingHandler()}
          />
        )}
        {formik.values.ordering ? (
          <ToggleButtonReuse
            mainText="Ordering"
            checkedBox={formik.values.ordering}
            onChange={() =>
              formik.setFieldValue("ordering", !formik.values.ordering)
            }
            clickHandle={(e) => {
              props.history.push({
                pathname: "/multi-service/ordering",
                state: { access: e },
              });
            }}
          />
        ) : (
          <ToggleButtonReuse
            mainText="Ordering"
            checkedBox={formik.values.ordering}
            onChange={() => orderingHandler()}
          />
        )}
        {formik.values.menu_setup ? (
          <ToggleButtonReuse
            mainText="Menu Setup"
            checkedBox={formik.values.menu_setup}
            onChange={() =>
              formik.setFieldValue("menu_setup", !formik.values.menu_setup)
            }
            clickHandle={(e) => {
              props.history.push({
                pathname: "/multi-service/menusetup",
                state: { access: e },
              });
            }}
          />
        ) : (
          <ToggleButtonReuse
            mainText="Menu Setup"
            checkedBox={formik.values.menu_setup}
            onChange={() => menuSetupHandler()}
          />
        )}
        <ToggleButtonReuse
          mainText="Voice Service Enable"
          checkedBox={formik.values.voice_services}
          onChange={() =>
            formik.setFieldValue("voice_services", formik.values.voice_services)
          }
          disabled={true}
        />
        <ToggleButtonReuse
          mainText="Manage Staff and Licenses"
          checkedBox={formik.values.manage_staff_licence}
          onChange={() =>
            formik.setFieldValue(
              "manage_staff_licence",
              formik.values.manage_staff_licence
            )
          }
          disabled={true}
        />
        <ToggleButtonReuse
          mainText="Amenities and Maintenance"
          checkedBox={formik.values.amenities_maintenance}
          onChange={() =>
            formik.setFieldValue(
              "amenities_maintenance",
              formik.values.amenities_maintenance
            )
          }
          disabled={true}
        />
        <ToggleButtonReuse
          mainText="Spa and Other Service"
          checkedBox={formik.values.spa_other_services}
          onChange={() =>
            formik.setFieldValue(
              "spa_other_services",
              formik.values.spa_other_services
            )
          }
          disabled={true}
        />
        <ToggleButtonReuse
          mainText="Attractions and Tour Package"
          checkedBox={formik.values.attraction_tour_packages}
          onChange={() =>
            formik.setFieldValue(
              "attraction_tour_packages",
              formik.values.attraction_tour_packages
            )
          }
          disabled={true}
        />
        <ToggleButtonReuse
          mainText="General Q&A and Information"
          checkedBox={formik.values.general_qa_info}
          onChange={() =>
            formik.setFieldValue(
              "general_qa_info",
              formik.values.general_qa_info
            )
          }
          disabled={true}
        />
      </div>
      <div className="onboarding-map-setup-screen-autodetect-button ">
        <ReusableOnboardingButton
          buttonTitle="Back Button"
          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
          buttonText="Back"
          buttonType="Submit"
          onClick={props.backButtonClicked}
        />
        <ReusableOnboardingButton
          buttonTitle="Next Button"
          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
          buttonText="Done"
          buttonType="Submit"
          onClick={() => onClickSave()}
        />
      </div>
      {/* </div> */}
      <Modal
        show={openModel}
        onHide={handleCloseSuccess}
        backdrop="static"
        centered
      >
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="text-center">
          <Image
            className="w-50 my-4"
            src={require("../../../../../assets/images/UserManagement/check-circle.svg")}
          />
          <div
            style={{ color: "#4caf50" }}
            className="f24_700_HelveticaNeue text-center pb-4"
          >
            Success!
          </div>
          <div className="f18-500">
            Thank You for Completing Subscription Settings.
          </div>
          <div className="f12-400 text-gray pb-5 pt-3 w-75 m-auto">
            You can come back to additional subscription as appropriate
          </div>
          {/* <Button
            variant="danger"
            className="w-100 btn-md py-2 mb-2"
            onClick={onCombackLater}
          >
            Login to Dashboard
          </Button> */}
          <Button
            variant="danger"
            // variant="outline-secondary"
            className="w-100 btn-md py-2 mb-2"
            onClick={onFinalSuccess}
          >
            Logout and Come Back Later
          </Button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
  // }
};

MultiServiceManagementScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription: state?.onboarding?.onboard_subscription_details,
  subscriptionData:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.multi_service_business_status,
  allSubscriptionsData: state?.onboarding?.onboard_subscription_details,
  restaurantDetails: state?.onboarding?.restaurantDetails,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
  logOutUser,
  update_vendor_profile,
})(withRouter(MultiServiceManagementScreen));
